import React from 'react';
import { useCalculateAverageSpeedByPath } from 'entities/navigation/hooks';
import { StatisticCard } from '../StatisticCard/StatisticCard';
import { useIntl } from 'react-intl';

export const SpeedCard = () => {
  const averageSpeed = useCalculateAverageSpeedByPath();
  const { formatMessage } = useIntl();

  return (
    <StatisticCard
      iconKind="speed"
      primaryText={`${averageSpeed} km/h`}
      secondaryText={formatMessage({ id: 'averageSpeed' })}
    />
  );
};
